<template>
        <div id='qgpage'>
              <NavTop title='双十一活动订货'/>
              <div class='maincon'>
                  <div class="goodsitem">
                      <div class="goodsitem-row">
                        <div class="goodsitem-col1"><img src='https://www.cnihz.cn/static/upload/img/20220502/2d011d0d91c8d8ef884aa09f8c634367.jpg.thumb.jpg'/></div>
                        <div class="goodsitem-col2">
                            <div class="goodsitem-col2-line1">蓉畅生物科技 真菌多糖NL18酵露2盒</div>
                            <div class="goodsitem-col2-line2"></div>
                            <div class="goodsitem-col2-line2"></div>
                            <div class="goodsitem-col2-line3">
                                <div class="goodsprice">¥398.00</div>
                                <div class="goodsnums"></div>
                            </div>
                        </div>
                      </div>
                  </div>
                  <div class="goodsitem nopadding">
                      <div class="goodsitem-row forceheight">
                        <div class="goodsitem-col1 bigcol">
                            <div class="couponcon-noused">
                                 <div>
                                    <span class="coupon-rmb">¥</span><span class="coupon-words1">1372</span>
                                 </div>
                                 <div>
                                    <span class="coupon-words2">满1372可用</span>
                                 </div> 
                            </div>
                        </div>
                        <div class="goodsitem-col2">
                            <div class="goodsitem-col2-line1 mt3">现金抵扣优惠券1张</div>
                            <div class="goodsitem-col2-line2">仅限向公司订货时使用</div>
                            <div class="goodsitem-col2-line2"></div>
                            <div class="goodsitem-col2-line3">
                                <div class="goodsprice"></div>
                                <div class="goodsnums">
                                    
                                </div>
                            </div>
                        </div>
                      </div>
                  </div>
              </div>
              <div class="bottomcon">
                  <div class="bottomcon-left"><div class="goodswords">优惠总价:</div><div class="goodsprice">¥1770</div></div>
                  <div class="bottomcon-right">
                      <div class="bottomcon-orderbtn" @click="goOrder">
                          <div class="bottomcon-orderbtn-words">立即抢购</div>
                      </div>
                  </div>
              </div>    
        </div>
</template>
<script>
import NavTop from '@/components/navtop'
export default {
  name: 'qgpage',
  created(){
    this.$store.commit('INIT_CART')
    this.$store.commit('INIT_ADDRESS')
  },
  methods:{
    goOrder(){
        this.$go("/couponorder");
    }
  },
  components:{
      NavTop
  }
}
</script>
<style scoped>
#qgpage{background-color:#F6F6F6;min-height: 100vh;}
.maincon{display: flex;flex-flow: column nowrap;margin-bottom: 100px;padding: 0 0.25rem;}
.goodsitem{display: flex;padding: 0.25rem;background-color: #fff;margin-top: 0.25rem;height: 3.0rem;align-items:center;border:1px solid #e7e7e7;border-radius: 0.15rem;}
.goodsitem-row{display: flex;flex-flow: row nowrap;justify-content: flex-start;width:100%;}
.goodsitem-col1 img{width:100%;}
.goodsitem-col2 {margin-left: 0.25rem;display: flex; flex-flow: column nowrap;text-align: left;}
.goodsitem-col2-line1{font-size: 0.35rem;}
.goodsitem-col2-line2{font-size: 0.3rem;color:#5e5e5e;margin-top: 0.15rem;}
.goodsitem-col2-line3{margin-top: 0.3rem;display: flex;flex-flow: row nowrap;}
.goodsnums{margin-left: auto;}
.goodsprice{color:#ff3600;font-size:0.4rem;display: flex;align-items: center;}
.bottomcon{display: flex;width:100%;background-color:#fff;height: 80px;position: fixed;left:0;bottom: 0;align-items: center;}
.bottomcon-left{display: flex;padding-left: 0.5rem;}
.goodswords{color:#333;font-size:0.35rem}
.bottomcon-right{margin-left: auto;padding-right: 0.3rem;}
.bottomcon-orderbtn{background-color:#ee0a24;color:#fff;height:1rem;width:3rem;border-radius: 0.15rem;display: flex;flex-flow: column nowrap;justify-content: center;}
.bottomcon-orderbtn-words{font-size:0.35rem;}

.forceheight{width:100%!important;height:100%!important;}
.nopadding{padding: 0!important;}
.couponcon-noused{display: flex;flex-flow: column nowrap;justify-content: center;align-items: center;background-color: #ee0a24;width:100%;height:100%;border-top-left-radius: 0.2rem;border-bottom-left-radius: 0.2rem;}
.couponcon-used{display: flex;flex-flow: column nowrap;justify-content: center;align-items: center;background-color: #9999;width:100%;height:100%;border-top-left-radius: 0.2rem;border-bottom-left-radius: 0.2rem;}
.coupon-rmb{font-size:0.30rem;color:#fff;}
.coupon-words1{font-size:0.45rem;color:#fff;}
.coupon-words2{font-size:0.30rem;color:#fff;}
.goodsitem-col1{width:2.8rem;}

.mt3{margin-top:0.3rem!important;}
.bigcol{width:3.05rem!important}
</style>


